// Client for /user_log endpoints.

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

/**
 * Log a post view impression (feed card or post page).
 * Auth is optional — send Bearer token when available.
 *
 * POST /user_log/log-view-post
 * Body: { post_id, cookie_id? }
 */
export async function logViewPost({ postId, token, cookieId } = {}) {
  if (!postId) return;

  const headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const body = { post_id: postId };
  if (cookieId) {
    body.cookie_id = cookieId;
  }

  const response = await fetch(`${baseAPI_URL}/user_log/log-view-post`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.error || "Failed to log post view");
  }

  return response.json().catch(() => ({ status: "success" }));
}

/**
 * Log a checkout funnel step (public checkout page).
 * Auth is optional — send Bearer token when available.
 *
 * POST /user_log/log-checkout-event
 * Body: { event_name, cookie_id, full_url }
 */
export async function logCheckoutEvent({ eventName, cookieId, token, fullUrl } = {}) {
  if (!eventName || !cookieId) return;

  const headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  try {
    const response = await fetch(`${baseAPI_URL}/user_log/log-checkout-event`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        event_name: eventName,
        cookie_id: cookieId,
        full_url: fullUrl || window.location.href,
      }),
    });
    if (!response.ok) {
      return null;
    }
    return response.json().catch(() => ({ status: "success" }));
  } catch (error) {
    return null;
  }
}
